import { TenantEntity } from '../TenantEntity'

export class ContainerUsage extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get isDirty() {
    return this._data.isDirty
  }
  set isDirty(isDirty) {
    this._data.dirty = isDirty
  }
  // ================================非db 字段，关联的箱子信息================================
  get container() {
    return this._data.container
  }
  set container(container) {
    this._data.container = container
  }

  get ediContainer() {
    return this._data.ediContainer
  }
  set ediContainer(ediContainer) {
    this._data.ediContainer = ediContainer
  }
  get ediContainers() {
    return this._data.ediContainers
  }
  set ediContainers(ediContainers) {
    this._data.ediContainers = ediContainers
  }
  get eqType() {
    return this._data.eqType
  }
  set eqType(eqType) {
    this._data.eqType = eqType
  }
  get eqSize() {
    return this._data.eqSize
  }
  set eqSize(eqSize) {
    this._data.eqSize = eqSize
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  get containerNo() {
    return this._data.containerNo
  }
  set containerNo(containerNo) {
    this._data.containerNo = containerNo
  }
  get sealNo() {
    return this._data.sealNo
  }
  set sealNo(sealNo) {
    this._data.sealNo = sealNo
  }
  get containerWeight() {
    return this._data.containerWeight
  }
  set containerWeight(containerWeight) {
    this._data.containerWeight = containerWeight || 0
  }
  get containerAscription() {
    return this._data.containerAscription
  }
  set containerAscription(containerAscription) {
    this._data.containerAscription = containerAscription
  }

  get operationTips() {
    return this._data.operationTips
  }
  set operationTips(operationTips) {
    this._data.operationTips = operationTips
  }

  get operationTipsDirty() {
    return this._data.operationTipsDirty
  }
  set operationTipsDirty(operationTipsDirty) {
    if (this._data.operationTipsDirty === operationTipsDirty) return
    this._data.isDirty = true
    this._data.operationTipsDirty = operationTipsDirty
  }

  get packing() {
    return this._data.packing
  }
  set packing(packing) {
    this._data.packing = packing
  }

  get boxController() {
    return this._data.boxController
  }
  set boxController(boxController) {
    this._data.boxController = boxController
  }

  get carNumber() {
    return this._data.carNumber
  }
  set carNumber(carNumber) {
    this._data.carNumber = carNumber
  }
  // ================================非db 字段，关联的箱子信息================================

  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    if (this._data.quantity === quantity) return
    this._data.isDirty = true
    this._data.quantity = quantity || 0
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    if (this._data.weight === weight) return
    this._data.isDirty = true
    this._data.weight = weight || 0
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    if (this._data.cubage === cubage) return
    this._data.isDirty = true
    this._data.cubage = cubage || 0
  }
  get masterJoin() {
    return this._data.masterJoin
  }
  set masterJoin(masterJoin) {
    if (this._data.masterJoin === masterJoin) return
    this._data.isDirty = true
    this._data.masterJoin = masterJoin
  }
  get serialNo() {
    return this._data.serialNo
  }
  set serialNo(serialNo) {
    if (this._data.serialNo === serialNo) return
    this._data.isDirty = true
    this._data.serialNo = serialNo
  }
  get hsCode() {
    return this._data.hsCode
  }
  set hsCode(hsCode) {
    if (this._data.hsCode === hsCode) return
    this._data.isDirty = true
    this._data.hsCode = hsCode
  }
  get soc() {
    return this._data.soc
  }
  set soc(soc) {
    if (this._data.soc === soc) return
    this._data.isDirty = true
    this._data.soc = soc
  }
  get truckingInfoUuid() {
    return this._data.truckingInfoUuid
  }
  set truckingInfoUuid(truckingInfoUuid) {
    if (this._data.truckingInfoUuid === truckingInfoUuid) return
    this._data.isDirty = true
    this._data.truckingInfoUuid = truckingInfoUuid
  }
  get type() {
    return this._data.type
  }
  set type(type) {
    if (this._data.type === type) return
    this._data.isDirty = true
    this._data.type = type
  }
  get code() {
    return this._data.code
  }
  set code(code) {
    if (this._data.code === code) return
    this._data.isDirty = true
    this._data.code = code
  }
  get description() {
    return this._data.description
  }
  set description(description) {
    if (this._data.description === description) return
    this._data.isDirty = true
    this._data.description = description
  }
  get truckingFee() {
    return this._data.truckingFee
  }
  set truckingFee(truckingFee) {
    if (this._data.truckingFee === truckingFee) return
    this._data.isDirty = true
    this._data.truckingFee = truckingFee
  }
  get truckStatus() {
    return this._data.truckStatus
  }
  set truckStatus(truckStatus) {
    if (this._data.truckStatus === truckStatus) return
    this._data.isDirty = true
    this._data.truckStatus = truckStatus
  }
  get driverNameHL() {
    return this._data.driverNameHL
  }
  set driverNameHL(driverNameHL) {
    if (this._data.driverNameHL === driverNameHL) return
    this._data.isDirty = true
    this._data.driverNameHL = driverNameHL
  }
  get driverPhoneHL() {
    return this._data.driverPhoneHL
  }
  set driverPhoneHL(driverPhoneHL) {
    if (this._data.driverPhoneHL === driverPhoneHL) return
    this._data.isDirty = true
    this._data.driverPhoneHL = driverPhoneHL
  }
  get truckNoHL() {
    return this._data.truckNoHL
  }
  set truckNoHL(truckNoHL) {
    if (this._data.truckNoHL === truckNoHL) return
    this._data.isDirty = true
    this._data.truckNoHL = truckNoHL
  }
  get tmsNoHL() {
    return this._data.tmsNoHL
  }
  set tmsNoHL(tmsNoHL) {
    if (this._data.tmsNoHL === tmsNoHL) return
    this._data.isDirty = true
    this._data.tmsNoHL = tmsNoHL
  }
  get containerNoDiff() {
    return this._data.containerNoDiff
  }
  set containerNoDiff(containerNoDiff) {
    this._data.containerNoDiff = containerNoDiff
  }
  get dcTicketNo() {
    return this._data.dcTicketNo
  }
  set dcTicketNo(dcTicketNo) {
    this._data.dcTicketNo = dcTicketNo
  }
  get dcSequence() {
    return this._data.dcSequence
  }
  set dcSequence(dcSequence) {
    this._data.dcSequence = dcSequence
  }
  get auditId() {
    return this._data.auditId
  }
  set auditId(auditId) {
    this._data.auditId = auditId
  }
  get auditUrl() {
    return this._data.auditUrl
  }
  set auditUrl(auditUrl) {
    this._data.auditUrl = auditUrl
  }
  get auditMoney() {
    return this._data.auditMoney
  }
  set auditMoney(auditMoney) {
    this._data.auditMoney = auditMoney
  }
  get auditState() {
    return this._data.auditState
  }
  set auditState(auditState) {
    this._data.auditState = auditState
  }
  get truckingPlaceOfDep() {
    return this._data.truckingPlaceOfDep
  }
  set truckingPlaceOfDep(truckingPlaceOfDep) {
    this._data.truckingPlaceOfDep = truckingPlaceOfDep
  }
  get truckingPlaceOfDest() {
    return this._data.truckingPlaceOfDest
  }
  set truckingPlaceOfDest(truckingPlaceOfDest) {
    this._data.truckingPlaceOfDest = truckingPlaceOfDest
  }
  get tosCarNum() {
    return this._data.tosCarNum
  }
  set tosCarNum(tosCarNum) {
    this._data.tosCarNum = tosCarNum
  }
  get tosDriverName() {
    return this._data.tosDriverName
  }
  set tosDriverName(tosDriverName) {
    this._data.tosDriverName = tosDriverName
  }
  get tosDriverPhone() {
    return this._data.tosDriverPhone
  }
  set tosDriverPhone(tosDriverPhone) {
    this._data.tosDriverPhone = tosDriverPhone
  }
  get tosTaskId() {
    return this._data.tosTaskId
  }
  set tosTaskId(tosTaskId) {
    this._data.tosTaskId = tosTaskId
  }
  get tosStartTime() {
    return this._data.tosStartTime
  }
  set tosStartTime(tosStartTime) {
    this._data.tosStartTime = tosStartTime
  }
  get tosEndTime() {
    return this._data.tosEndTime
  }
  set tosEndTime(tosEndTime) {
    this._data.tosEndTime = tosEndTime
  }
  get tosGstartTime() {
    return this._data.tosGstartTime
  }
  set tosGstartTime(tosGstartTime) {
    this._data.tosGstartTime = tosGstartTime
  }
  get tosGarriveTime() {
    return this._data.tosGarriveTime
  }
  set tosGarriveTime(tosGarriveTime) {
    this._data.tosGarriveTime = tosGarriveTime
  }
  get tosInTime() {
    return this._data.tosInTime
  }
  set tosInTime(tosInTime) {
    this._data.tosInTime = tosInTime
  }
  get tosGinTime() {
    return this._data.tosGinTime
  }
  set tosGinTime(tosGinTime) {
    this._data.tosGinTime = tosGinTime
  }
  get tosOutTime() {
    return this._data.tosOutTime
  }
  set tosOutTime(tosOutTime) {
    this._data.tosOutTime = tosOutTime
  }
  get tosGoutTime() {
    return this._data.tosGoutTime
  }
  set tosGoutTime(tosGoutTime) {
    this._data.tosGoutTime = tosGoutTime
  }
  get tosNodeDate() {
    return this._data.tosNodeDate
  }
  set tosNodeDate(tosNodeDate) {
    this._data.tosNodeDate = tosNodeDate
  }
  get tosLocation() {
    return this._data.tosLocation
  }
  set tosLocation(tosLocation) {
    this._data.tosLocation = tosLocation
  }
  get tosErrorType() {
    return this._data.tosErrorType
  }
  set tosErrorType(tosErrorType) {
    this._data.tosErrorType = tosErrorType
  }
  get tosErrorMessage() {
    return this._data.tosErrorMessage
  }
  set tosErrorMessage(tosErrorMessage) {
    this._data.tosErrorMessage = tosErrorMessage
  }
  get cargoName() {
    return this._data.cargoName
  }
  set cargoName(cargoName) {
    if (this._data.cargoName === cargoName) return
    this._data.isDirty = true
    this._data.cargoName = cargoName
  }
  get mark() {
    return this._data.mark
  }
  set mark(mark) {
    if (this._data.mark === mark) return
    this._data.isDirty = true
    this._data.mark = mark
  }
  get quantityContract() {
    return this._data.quantityContract
  }
  set quantityContract(quantityContract) {
    if (this._data.quantityContract === quantityContract) return
    this._data.isDirty = true
    this._data.quantityContract = quantityContract || 0
  }
  get weightContract() {
    return this._data.weightContract
  }
  set weightContract(weightContract) {
    if (this._data.weightContract === weightContract) return
    this._data.isDirty = true
    this._data.weightContract = weightContract || 0
  }
  get cubageContract() {
    return this._data.cubageContract
  }
  set cubageContract(cubageContract) {
    if (this._data.cubageContract === cubageContract) return
    this._data.isDirty = true
    this._data.cubageContract = cubageContract || 0
  }
  get containerUuid() {
    return this._data.containerUuid
  }
  set containerUuid(containerUuid) {
    if (this._data.containerUuid === containerUuid) return
    this._data.isDirty = true
    this._data.containerUuid = containerUuid
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    if (this._data.jobUuid === jobUuid) return
    this._data.isDirty = true
    this._data.jobUuid = jobUuid
  }
  get socType() {
    return this._data.socType
  }
  set socType(socType) {
    this._data.socType = socType
  }
  // 箱ID
  get containerId() {
    return this._data.containerId
  }
  set containerId(containerId) {
    this._data.containerId = containerId
  }
  // 箱序号
  get containerSeqNo() {
    return this._data.containerSeqNo
  }
  set containerSeqNo(containerSeqNo) {
    this._data.containerSeqNo = containerSeqNo
  }
}
